export default function({ data, keys, valueKey }) {
  const hash = {}
  const result = []
  // console.log('data from stack.js', data)
  data.forEach(d => {
    let compoundKey = ''
    keys.forEach((k, i) => {
      if (i === 0) {
        compoundKey = `${d[k]}`
      } else {
        compoundKey = `${compoundKey}|${d[k]}`
      }
    })
    // console.log('compoundKey', compoundKey)

    if (!hash[compoundKey]) hash[compoundKey] = 0
    hash[compoundKey] += d[valueKey]
  })

  // console.log('hash', hash)

  Object.keys(hash).forEach(k => {
    const sum = hash[k]
    const values = k.split('|')
    const d = {
      [valueKey]: sum
    }

    keys.forEach((key, i) => {
      d[key] = values[i]
    })

    result.push(d)
  })

  return result
}
